// lib/brands/locationReview.ts
/** This marker checks name matching, not whether an establishment is a shopfront. */
export function parseReviewVerdict(raw: string | null | undefined): 'GO' | 'CLOSED' | 'NOGO' | null {
  const verdicts = [...(raw ?? '').matchAll(/review:[^:|]*:(GO|CLOSED|NOGO)\b/gi)].map(match => match[1]!.toUpperCase());
  if (verdicts.includes('NOGO')) return 'NOGO';
  if (verdicts.includes('CLOSED')) return 'CLOSED';
  return verdicts.includes('GO') ? 'GO' : null;
}
